import { TurboFrameRenderEvent } from '@hotwired/turbo'
import { showError, showSuccess } from './toastify-js'

type FlashData = {
  notice: string
  alert: string
}

document.addEventListener('turbo:before-fetch-response', (event: Event) => {
  const json = (event as TurboFrameRenderEvent).detail.fetchResponse.header('X-Flash-Messages')
  if (!json) return

  const flashData: FlashData = JSON.parse(json)

  if (flashData.notice) {
    showSuccess(flashData.notice)
  } else if (flashData.alert) {
    showError(flashData.alert)
  }
})
